<template>
  <div>
    <div class="title">
      <p>支付结果</p>
    </div>
    <div>
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 0.8rem;
        "
      >
        <van-icon name="checked" color="#32CD32" size="1.6rem" />
        <div style="font-size: 0.39rem; margin-top: 10px">支付成功</div>
        <p style="margin-top: 10px; font-size: 0.15rem; color: #dcdcdc">
          支付成功,您可前往订单页查看订单状态
        </p>
      </div>
      <div style="margin-top: 1rem; margin-left: 20px">
        <van-steps direction="vertical" :active="0">
          <van-step>
            <h3>下单时间</h3>
            <p>2016-07-12 12:40</p>
          </van-step>
          <van-step>
            <h3>预计检测完成时间</h3>
            <p>2小时内</p>
          </van-step>
        </van-steps>
      </div>
      <div>
        <van-button
          plain
          color="#666666"
          style="
            margin: 1.87rem auto;
            display: block;
            padding: 0 65px;
            letter-spacing: 10px;
          "
          @click="toPayResult"
          >完成</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isphone: false,
      phone: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    document
      .querySelector(".app")
      .setAttribute("style", "background-color:#fff");
    next();
  },
  created() {
    let orderid = this.getUrlParam("out_trade_no");
    orderid = orderid.slice(0, 17);
    this.$http
      .getIsPhone(orderid)
      .then((res) => {
        if (res.data.phone) {
          this.isphone = true;
          this.phone = res.data.phone;
        } else {
          this.isphone = false;
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  },
  methods: {
    toPayResult() {
      if (this.isphone) {
        this.$router.push(`/queryorder?phone=${this.phone}`);
      } else {
        this.$router.push("/report");
      }
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
};
</script>

<style scoped>
.title p {
  height: 0.8rem;
  background: #228ef7;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
}
</style>